import {
  collection,
  doc,
  limit,
  orderBy,
  query,
  type DocumentReference,
  type DocumentSnapshot,
} from 'firebase/firestore'
import { getDb } from '@/firebase/firestore'
import { normalizeMap } from '@/firebase/converters'
import type { AlertDoc, AlertRecord } from '@/types/firestore'

/* users/{uid}/alerts/{alertId}. */

export function userRef(uid: string): DocumentReference {
  // getUserRefFromUID (custom_functions.dart): collection('users').doc(uid)
  return doc(getDb(), 'users', uid)
}

/** AlertsRecord.parentReference: reference.parent.parent — users/{uid}. */
export function alertParentRef(alertRef: DocumentReference): DocumentReference {
  const parent = alertRef.parent.parent
  if (!parent) throw new Error(`alert ref has no parent user: ${alertRef.path}`)
  return parent
}

/* Tracking's level-3 query (tracking_widget.dart):
 *   queryAlertsRecord(parent: users/{uid},
 *     queryBuilder: orderBy('createdAt', descending: true), limit: 10) */
export function alertsQuery(parent: DocumentReference) {
  return query(
    collection(parent.firestore, parent.path, 'alerts'),
    orderBy('createdAt', 'desc'),
    limit(10),
  )
}

export function parseAlert(snap: DocumentSnapshot): AlertRecord {
  const data = normalizeMap(snap.data() ?? {}) as AlertDoc
  return { ref: snap.ref, data }
}
